export const FIRMWARELIST_DETAILS = 'FIRMWARELIST_DETAILS';
export const FIRMWARELIST_DETAILS_BY_ID = 'FIRMWARELIST_DETAILS_BY_ID';
